import { Stack, IconButton, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SegmentIcon from "@mui/icons-material/Segment";
import TerminalIcon from "@mui/icons-material/Terminal";
import ImageIcon from "@mui/icons-material/Image";
import SettingsIcon from "@mui/icons-material/Settings";
import PaletteIcon from "@mui/icons-material/Palette"; // Add an icon for theme
import WidgetsIcon from "@mui/icons-material/Widgets"; // Add an icon for components
import { TControls } from "features/lightningLanders/types";
import { useLightningLanderContext } from "features/lightningLanders/providers/LightningLanderProvider";
import { ApiComponentType } from "@incendium/api";

interface ILightningLanderControlsProps {
  control: TControls;
  setControl: (v: TControls) => void;
}

function LightningLanderControls({
  control,
  setControl,
}: ILightningLanderControlsProps) {
  const theme = useTheme();
  const { component } = useLightningLanderContext();

  return (
    <Stack
      sx={{
        height: "100%",
        padding: 1,
        backgroundColor: "#edf1fe",
        borderRight: `1px solid ${theme.palette.divider2}`,
      }}
    >
      <IconButton
        color={control === "elements" ? "primary" : "secondary"}
        onClick={() => setControl("elements")}
      >
        <AddIcon />
      </IconButton>
      <IconButton
        color={control === "layout" ? "primary" : "secondary"}
        onClick={() => setControl("layout")}
      >
        <SegmentIcon />
      </IconButton>
      {component.type !== ApiComponentType.LANDING_BLOCK &&
        component.type !== ApiComponentType.LANDING_COMPONENT && (
          <IconButton
            color={control === "head" ? "primary" : "secondary"}
            onClick={() => setControl("head")}
          >
            <TerminalIcon />
          </IconButton>
        )}
      <IconButton
        color={control === "media" ? "primary" : "secondary"}
        onClick={() => setControl("media")}
      >
        <ImageIcon />
      </IconButton>
      {component.type === ApiComponentType.LANDING && (
        <IconButton
          color={control === "settings" ? "primary" : "secondary"}
          onClick={() => setControl("settings")}
        >
          <SettingsIcon />
        </IconButton>
      )}
      {component.type !== ApiComponentType.LANDING_BLOCK &&
        component.type !== ApiComponentType.LANDING_COMPONENT && (
          <IconButton
            color={control === "theme" ? "primary" : "secondary"}
            onClick={() => setControl("theme")}
          >
            <PaletteIcon />
          </IconButton>
        )}
      {component.type !== ApiComponentType.LANDING_COMPONENT && (
        <IconButton
          color={control === "components" ? "primary" : "secondary"}
          onClick={() => setControl("components")}
        >
          <WidgetsIcon />
        </IconButton>
      )}
    </Stack>
  );
}

export default LightningLanderControls;
